export default __webpack_public_path__ + "static/media/samsung.49a2b82e.svg";